'use strict';
require('./warnAboutDeprecatedCJSRequire.js')('createBrowserHistory');
module.exports = require('./index.js').createBrowserHistory;



//////////////////
// WEBPACK FOOTER
// ./~/history/createBrowserHistory.js
// module id = 763
// module chunks = 0